import React, { useEffect } from "react";
import { NOTIFICATION_SUBJECTS } from "utils/constants";

import { openedNotificationSet, pendingNotificationSet, selectOpenedNotification, selectPendingNotification, selectSlideOut } from "slices/notificationsSlice";
import { useAppDispatch, useAppSelector } from "store";
import { MinimizedWrapper, OpenFull, ProjectName, Title, Dot } from "./styles";

const MinimizedNotification = () => {
  const dispatch = useAppDispatch();
  const pendingNotification = useAppSelector(selectPendingNotification);
  const openedNotification = useAppSelector(selectOpenedNotification);
  const slideOut = useAppSelector(selectSlideOut);

  const { type, data } = pendingNotification || { type: "", data: null };

  const clearMinimized = () => {
    dispatch(pendingNotificationSet(null));
  };

  const openFullNotification = () => {
    dispatch(openedNotificationSet(pendingNotification));
    dispatch(pendingNotificationSet(null));
  };

  useEffect(() => {
    if (openedNotification) clearMinimized();
  }, [openedNotification]);

  if (!data || slideOut) return null;

  return (
    <MinimizedWrapper onClick={openFullNotification}>
      <ProjectName>{data.projectName}</ProjectName>
      <Title>
        {NOTIFICATION_SUBJECTS[type]}
        <Dot icon="unreadNotification" noWrapper />
      </Title>
      <OpenFull icon="openFullScreen" />
    </MinimizedWrapper>
  );
};

export default MinimizedNotification;
